<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_label_gen&& localService.languageContent.table">
        <div class="banner center" style="max-width:800px;">
            <div class="row row_header freeze_height">
                <div class="col-4 wrap-div" style="text-align: left;">
                    <button class="button_icon button_icon_color icon_adjust"
                        (click)="onAction(1)">file_download</button>
                    <span style="margin-left: 5px;">{{localService.languageContent.qr_label_gen.uploaded_data}}</span>
                </div>
                <div class="col-4 wrap-div" style="text-align: left;">
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.split_range}}"
                        [(ngModel)]="maxRange" style="width:calc(100% - 40px);"
                        placeholder="{{localService.languageContent.qr_label_gen.split_range}}"
                        title="{{localService.languageContent.qr_label_gen.split_range}}"
                        [ngClass]="maxRange ? 'en' : ''" />
                    <app-file-upload [Id]="elementIds.fileUpload" (onFileUploaded)="onLoad()" [forId]="templateId"
                        [forId2]="businessId" [forId3]="maxRange" [fileUploadFor]="FileUploadFor.QrLabelGenerator"
                        [topPosition]="6" style="float: right;" />
                </div>
                <div class="col-4 wrap-div" style="text-align: right;">
                    <label style="font-weight: normal; margin-left: 15px;">
                        <input type="checkbox" [(ngModel)]="isShowDeleted" (change)="onLoad()" />
                        <span class="normal_color">{{localService.languageContent.qr_label_gen.show_deleted}}</span>
                    </label>
                </div>
            </div>
            <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div *ngIf="(source && source.items.length > 0)" class="item-found">
                    <div class="row styled_row" *ngFor="let item of source.items">
                        <div class="col-5 wrap-div">
                            <button class="button_icon icon_adjust"
                                title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                                (click)="onActiveInactiveStatus(item.key)"
                                [ngStyle]="{'color': item.v4 == '1' ? 'orangered' : 'yellowgreen' }">{{item.v4 =='1' ?
                                'cancel' : 'restore'}}</button>
                            <span class="en" title="{{item.v1}}">{{item.v1}}</span>
                        </div>
                        <div class="col-3 wrap-div">
                            <button class="button_icon button_icon_color icon_adjust"
                                (click)="onAction(2,item.key)">qr_code</button>
                            <span class="en">&nbsp;[{{item.v2}} - {{item.v3}}]</span>
                        </div>
                        <div class="col-4 wrap-div">
                            <span class="en">{{item.v5 | date : 'dd-MMM-yyyy hh:mm a'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-paging *ngIf="source && source.paging" [paging]="source.paging" [IsSimple]="true"
            (onPagingRefreshed)="onLoad()" [IsSimpleSearchBarReq]="false" />
    </div>
</div>
<div *ngIf="businessId && businessId.length > 5">
    <span style="display: none;">
        <button class="after_access_check" (click)="onInitiate()">After Access Check</button>
    </span>
</div>
<div *ngIf="source">
    <app-qr-label-preview-settings *ngIf="selectedTemplateFor && selectedTemplateFor > 0"
        [(isOpenPopup)]="isOpenLabelPreviewSettings" [countryCode]="ctryCode" [businessId]="businessId"
        [selectedTemplateId]="templateId" [templateFor]="selectedTemplateFor"
        (onHtmlGenerated)="onHtmlGenerated($event)" [selectedUploaId]="selectedUploaId" [isUploadedData]="true" />
    <app-html-viewer [isPopUp]="true" [isIframe]="true" [printHtml]="printHtml" (onClose)="printHtml = undefined" />
</div>